import React, { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { uploadFile } from '../../../../../../api/api'
import { editorUpdateLogo } from '../../../../../../store/pages-management/actions'
import { LogoProps as Props } from './types'
import upload from '../../../../../../assets/img/upload.png'

const Logo: FC<Props> = ({ strings }) => {
  // REDUX STORE
  const dispatch = useDispatch()

  // State
  const [ uploadedImage, setUploadedImage ] = useState<string>('')

  /**
   * Handles the uploaded file response
   *
   * @param response
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleUploadFileReceived = (response: any) => {
    if (response.success) {
      dispatch(editorUpdateLogo(response.url))

      setUploadedImage(response.url)
    } else {
      alert(strings.alert_upload)
    }
  }

  /**
   * Handles the image upload
   *
   * @param file
   * @returns {Promise<void>}
   */
  const uploadImage = async (file: File) => {
    if (file && file.name.match(/.(jpg|jpeg|png|gif)$/i)) {
      if (file.size < 5000000) {
        const response = await uploadFile(file, 'plann3r-company-logos')
        handleUploadFileReceived(response)
      } else {
        alert(strings.alert_file_smaller)
      }
    } else {
      alert(strings.alert_unsupported_file)
    }
  }

  return (
    <div className="part logo">
      <h3 className="part_header">{ strings.logo }</h3>
      <div>
        <div>
          <img alt="Upload Logo" src={ uploadedImage ? uploadedImage : upload } />
          <input
            type="file"
            id="uploadfile"
            hidden
            onChange={ (e) => e.target.files && uploadImage(e.target.files[0]) }
          />
        </div>
        <div>
          <button
            className="button is-primary"
            onClick={ () => document.getElementById('uploadfile')?.click() }
            style={{ marginRight: '10px' }}
          >
            { strings.choose_file }
          </button>
          <br />
          <span>{ strings.best_to_pick }</span>
        </div>
      </div>
    </div>
  )
}

export default Logo